import { ExternalLink } from 'lucide-react';
import { BILIBILI_URL, GITHUB_URL } from '../siteContent';

export default function Footer({ content, navLinks }) {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <a className="brand" href="#top" aria-label="NEXT Engine home">
          <img className="brand-icon" src="/icon.svg" alt="NEXT Engine icon" />
          <span className="brand-text">NEXT Engine</span>
        </a>
        <div className="footer-copy">
          <p>{content.text}</p>
          <small>{content.copyright}</small>
        </div>
        <div className="footer-links">
          {navLinks.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
          <a href={GITHUB_URL} target="_blank" rel="noopener noreferrer" className="footer-github">
            <ExternalLink size={14} />
            GitHub
          </a>
          <a href={BILIBILI_URL} target="_blank" rel="noopener noreferrer" className="footer-github">
            <ExternalLink size={14} />
            {content.bilibili}
          </a>
        </div>
      </div>
    </footer>
  );
}
